import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199f0289"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "location-picker"
}
const _hoisted_2 = { class: "marker-content" }
const _hoisted_3 = { class: "marker-name" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "img-block" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  onclick: "this.paused ? this.play() : this.pause();",
  autoplay: "true",
  class: "video-preview"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = {
  key: 0,
  class: "content-title"
}
const _hoisted_12 = { key: 0 }

import { computed, onMounted, ref, useAttrs } from 'vue'
import { GoogleMap, CustomMarker, MarkerCluster, Polyline } from 'vue3-google-map'
import { useFilterPageStore } from '@/stores/filterPageStore'
import { MEDIA_TYPE } from '@/models/AdditionalDataTypes'
import { HybridMapDto, StoryPreviewDto } from '@/models/FilterPageTypes'



export default /*#__PURE__*/_defineComponent({
  __name: 'TourHybridDetailsMap',
  setup(__props) {

const mapId = ref('dbae89d434244c00') // map style created in web ui (https://console.cloud.google.com/google/maps-apis/studio/maps)
const zoom = ref(13)
const attrs = useAttrs()

const stories = ref<StoryPreviewDto[]>([])
const selectedStory = ref<StoryPreviewDto | undefined>()
const isSelectedStoryShowing = ref(false)

const filterPageStore = useFilterPageStore()

const correctCoords = computed(() => {
    try {
        const coords = stories.value.map(i => i.Coords).filter(i => i.lat && i.lng)
        return coords
    } catch (error) {
        return Array<{ lat: number; lng: number }>()
    }
})
const isCoordsExist = computed(() => {
    try {
        const isExists = correctCoords.value.length > 0
        return isExists
    } catch (error) {
        return false
    }
})
const polyLines = computed(() => ({
    path: correctCoords.value,
    geodesic: true,
    strokeColor: '#1C613B',
    strokeOpacity: 1.0,
    strokeWeight: 5,
}))
const mapCenter = computed(() => correctCoords.value[0] ?? { lat: 35, lng: 31 })
const tourId = computed(() => (attrs.tourId) as number)
const gmapKey = computed(() => filterPageStore.googleMapKey)

const culture = computed(() => document.documentElement.dataset.culture?.toString() ?? '')

const onMarkerClick = (e: MouseEvent, story: StoryPreviewDto) => {
    isSelectedStoryShowing.value = selectedStory.value?.KeyId === story.KeyId ? !isSelectedStoryShowing.value : true
    selectedStory.value = story
}

onMounted(async () => {
    try {
        const data = (await filterPageStore.getStoriesByTourId(tourId.value)) as HybridMapDto
        stories.value = [...data.Stories]
    } catch (error) {
        console.error('Cannot get route for tour', error)
        location.replace("/404")
    }
})

return (_ctx: any,_cache: any) => {
  return (_unref(isCoordsExist) && _unref(gmapKey))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(GoogleMap), {
          "fullscreen-control": false,
          "street-view-control": false,
          "map-type-control": false,
          "map-id": mapId.value,
          "api-key": _unref(gmapKey),
          language: _unref(culture),
          class: "map",
          center: _unref(mapCenter),
          zoom: zoom.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(MarkerCluster), null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stories.value, (story, index) => {
                  return (_openBlock(), _createBlock(_unref(CustomMarker), {
                    key: story.KeyId,
                    tabindex: "0",
                    options: { position: story.Coords },
                    onKeyup: _withKeys(($event: any) => (onMarkerClick($event, story)), ["enter"]),
                    onClick: ($event: any) => (onMarkerClick($event, story)),
                    class: "custom-marker"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(story.Title), 1),
                        _createElementVNode("p", null, _toDisplayString(index + 1), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["options", "onKeyup", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_unref(Polyline), { options: _unref(polyLines) }, null, 8, ["options"])
          ]),
          _: 1
        }, 8, ["map-id", "api-key", "language", "center", "zoom"]),
        (selectedStory.value && isSelectedStoryShowing.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "tour-map-item",
              href: selectedStory.value.DetailsUrl,
              target: "_blank"
            }, [
              _createElementVNode("div", _hoisted_5, [
                (selectedStory.value.PreviewDesktop.Url)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (selectedStory.value.PreviewDesktop.Type == _unref(MEDIA_TYPE).Image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "d-none d-lg-block img-fluid",
                            src: selectedStory.value.PreviewDesktop.Url,
                            alt: selectedStory.value.PreviewDesktop.Alt
                          }, null, 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      (selectedStory.value.PreviewDesktop.Type === _unref(MEDIA_TYPE).Video)
                        ? (_openBlock(), _createElementBlock("video", _hoisted_7, [
                            _createElementVNode("source", {
                              src: selectedStory.value.PreviewDesktop.Url,
                              type: "video/mp4"
                            }, null, 8, _hoisted_8)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (selectedStory.value.PreviewMobile.Url)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (selectedStory.value.PreviewDesktop.Type == _unref(MEDIA_TYPE).Image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "d-block d-lg-none img-fluid",
                            src: selectedStory.value.PreviewMobile.Url,
                            alt: selectedStory.value.PreviewMobile.Alt
                          }, null, 8, _hoisted_9))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (selectedStory.value.Title)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(selectedStory.value.Title), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  (selectedStory.value.Description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(selectedStory.value.Description), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_4))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})